/* vc-home-motion.js — shared motion runtime for the new home page sections.
   Owns the single requestAnimationFrame loop that the carousels and the
   before/after slider register with, and the IntersectionObserver fallback for
   scroll reveals on browsers without animation-timeline: view().
   Loaded with defer. */
(function () {
  'use strict';

  if (window.VCHome) return;

  var reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* ---------------------------------------------------------------------- */
  /* One shared rAF loop, paused while the tab is hidden.                   */
  /* ---------------------------------------------------------------------- */
  var jobs = [];
  var raf = 0;

  function frame(t) {
    raf = 0;
    for (var i = 0; i < jobs.length; i++) {
      try {
        jobs[i](t);
      } catch (e) {}
    }
    if (jobs.length && !document.hidden) raf = requestAnimationFrame(frame);
  }

  function start() {
    if (!raf && jobs.length && !document.hidden) raf = requestAnimationFrame(frame);
  }

  function stop() {
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
    } else {
      /* Reset each job's clock so it does not jump after a long pause. */
      for (var i = 0; i < jobs.length; i++) {
        if (jobs[i].reset) jobs[i].reset();
      }
      start();
    }
  });

  var VCHome = {
    reduce: reduce,

    /* Register a per-frame callback. Returns an unsubscribe function. */
    addJob: function (fn) {
      jobs.push(fn);
      start();
      return function () {
        var i = jobs.indexOf(fn);
        if (i > -1) jobs.splice(i, 1);
        if (!jobs.length) stop();
      };
    },

    /* Does this browser drive animations from scroll on its own? */
    hasViewTimeline: function () {
      try {
        return !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()'));
      } catch (e) {
        return false;
      }
    },

    /* Shared easing helpers */
    easeInOutQuad: function (x) {
      return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    },

    clamp: function (v, lo, hi) {
      return v < lo ? lo : v > hi ? hi : v;
    }
  };

  window.VCHome = VCHome;

  /* ---------------------------------------------------------------------- */
  /* Scroll reveals.                                                        */
  /* Only runs when the browser cannot do animation-timeline: view(), so we  */
  /* never animate the same element twice.                                  */
  /* ---------------------------------------------------------------------- */
  function initReveals() {
    if (reduce) return;
    if (VCHome.hasViewTimeline()) return;
    if (!('IntersectionObserver' in window)) return;

    /* Tell the stylesheet to take the JS path. */
    document.documentElement.classList.add('vch-js-motion');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting || en.intersectionRatio >= 0.15) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: [0, 0.15], rootMargin: '0px 0px -5% 0px' }
    );

    function observe(root) {
      (root || document)
        .querySelectorAll('.vch-anim .vch-reveal:not(.is-in), .vch-anim .vch-unveil:not(.is-in)')
        .forEach(function (el) {
          io.observe(el);
        });
    }

    observe(document);
    VCHome.observeReveals = observe;

    /* Anything above the fold on load should not sit invisible. */
    requestAnimationFrame(function () {
      document
        .querySelectorAll('.vch-anim .vch-reveal:not(.is-in), .vch-anim .vch-unveil:not(.is-in)')
        .forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.9) {
            el.classList.add('is-in');
            io.unobserve(el);
          }
        });
    });

    /* The theme editor re-renders sections in place. */
    document.addEventListener('shopify:section:load', function (e) {
      observe(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveals);
  } else {
    initReveals();
  }
})();
